<template>
    <div class="BlogHeader">
        <blog-avatar :blog="blog" :w="200" :h="200"/>
        <h1>{{blog.title}}</h1>
        <p class="lead">{{cleanDesc}}</p>
        <p><follow-button :blog="blog" /></p>
    </div>
</template>

<script>

    import Swal from 'vue-sweetalert';
    import BlogAvatar from '../ui/BlogAvatar.vue';
    import FollowButton from '../ui/buttons/FollowButton.vue';

    export default {
        props: {
            blog:{
                defaults: {
                    _id: 0,
                    title: '',
                    description: ''
                }
            }
        },
        data() {
            return {}
        },
        computed:{
            cleanDesc(){
              let div = document.createElement("div");
              div.innerHTML = this.blog.description || "";
              return div.textContent || div.innerText || "";
            }
        },
        created() {

        },
        methods: {

        },
        components:{
            BlogAvatar,
            FollowButton
        }
    }
</script>

<style lang="sass" scoped>
    .BlogHeader
        text-align: center
        padding: 2em 0
</style>



// WEBPACK FOOTER //
// src/components/blogs/BlogHeader.vue